import React from 'react';
import utilsService from '../../../servises/utils.service';
import styled from 'styled-components';

const AlarmContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const MetaGridStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  gap: 12px;
`;

const MetaCardStyled = styled.div`
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid var(--border-color);
  padding: 10px 12px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const MetaLabelStyled = styled.span`
  color: var(--text-muted);
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const MetaValueStyled = styled.span`
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
`;

const SeverityBadgeStyled = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  border: 1px solid;
  
  &.critical {
    background: rgba(244, 63, 94, 0.08);
    border-color: rgba(244, 63, 94, 0.25);
    color: #f43f5e;
  }
  
  &.warning {
    background: rgba(245, 158, 11, 0.08);
    border-color: rgba(245, 158, 11, 0.25);
    color: #f59e0b;
  }
  
  &.info {
    background: rgba(14, 165, 233, 0.08);
    border-color: rgba(14, 165, 233, 0.25);
    color: #0ea5e9;
  }
`;

const MessageCalloutStyled = styled.div`
  background: rgba(255, 255, 255, 0.015);
  border: 1px solid var(--border-color);
  border-left: 4px solid ${props => props.color};
  padding: 14px 16px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-primary);
  word-break: break-word;
`;

const CompactContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.85);

  .compact-row {
    display: flex;
    justify-content: space-between;
    gap: 8px;
  }

  .compact-label {
    color: var(--text-muted);
    font-weight: 600;
  }

  .compact-value {
    color: var(--text-primary);
  }

  .compact-message {
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    padding-top: 6px;
    margin-top: 2px;
    color: var(--text-primary);
    word-break: break-word;
  }

  span.info {
    color: #0ea5e9;
    font-weight: 700;
  }

  span.warning {
    color: #f59e0b;
    font-weight: 700;
  }

  span.critical {
    color: #f43f5e;
    font-weight: 700;
  }
`;

const getSeverityColor = (severityClass) => {
    switch (severityClass) {
        case 'critical':
            return '#f43f5e';
        case 'warning':
            return '#f59e0b';
        case 'info':
        default:
            return '#0ea5e9';
    }
};

const AlarmMoreInfo = ({ alarm, severity, text, compact = false }) => {
    let monitorTypeLabel = 'Server';
    if (alarm.monitorType === 'uptime') {
        monitorTypeLabel = 'Uptime';
    }

    const severityColor = getSeverityColor(severity.classes);

    if (compact) {
        return (
            <CompactContainerStyled>
                <div className="compact-row">
                    <span className="compact-label">{ monitorTypeLabel }:</span>
                    <span className="compact-value">{ alarm.serverName }</span>
                </div>
                <div className="compact-row">
                    <span className="compact-label">Severity:</span>
                    <span className={ severity.classes }>{ severity.text }</span>
                </div>
                <div className="compact-row">
                    <span className="compact-label">Date:</span>
                    <span className="compact-value">{ utilsService.dateMeWithTime(alarm.createdAt) }</span>
                </div>
                <div className="compact-message">
                    { text }
                </div>
            </CompactContainerStyled>
        );
    }

    return (
        <AlarmContainerStyled>
            <MetaGridStyled>
                <MetaCardStyled>
                    <MetaLabelStyled>Monitor Type</MetaLabelStyled>
                    <MetaValueStyled>{ monitorTypeLabel }</MetaValueStyled>
                </MetaCardStyled>
                <MetaCardStyled>
                    <MetaLabelStyled>Target</MetaLabelStyled>
                    <MetaValueStyled>{ alarm.serverName }</MetaValueStyled>
                </MetaCardStyled>
                <MetaCardStyled>
                    <MetaLabelStyled>Severity</MetaLabelStyled>
                    <MetaValueStyled>
                        <SeverityBadgeStyled className={ severity.classes }>
                            { severity.text }
                        </SeverityBadgeStyled>
                    </MetaValueStyled>
                </MetaCardStyled>
                <MetaCardStyled>
                    <MetaLabelStyled>Date & Time</MetaLabelStyled>
                    <MetaValueStyled>
                        { utilsService.dateMeWithTime(alarm.createdAt) }
                    </MetaValueStyled>
                </MetaCardStyled>
            </MetaGridStyled>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <MetaLabelStyled style={{ paddingLeft: '4px' }}>Details</MetaLabelStyled>
                <MessageCalloutStyled color={ severityColor }>
                    { text }
                </MessageCalloutStyled>
            </div>
        </AlarmContainerStyled>
    );
};

export default AlarmMoreInfo;

